import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import _, { pad } from "lodash";
import cx from "classnames";
import { Frame } from "scenejs";
import { Dropdown, Form } from "react-bootstrap";

import { Property } from "../../components/properties";
import { components } from "react-select";
import {
  FontBackgroundSettings,
  SeekLayoutSettings,
} from "./components/properties";
import { Widgets } from "@paperflite-marketing/cleverstory-commons";
import ResponsiveDesign from "./components/designModal";

import { EditorContext } from "../../index";
import { updateWidgetProperty } from "actions/editor";
import { getColorsConfig } from "services/cssHelper.service";
import {
  useChildrenWidgetSelected,
  usePageWidgetSelector,
} from "components/Editor/hooks/useEditorSession";
import StoryboardContext from "components/Storyboard/context";
import { getBoundingRectFromLayout } from "components/Editor/helper/layoutManager";
import { BrandComponentProperty } from "components/Editor/components/brandElements";
import userRoleService from "services/userRoles.service";
import { getWidgetType } from "components/Editor/helper/widget";
import { PAGE } from "constants/widgetTypes";

import styles from "./seek.module.scss";

const SeekWidgetViewComponent = function ({
  className,
  style,
  widgetProps,
  widgetRef,
}) {
  const ref = widgetRef;

  const editorContext = React.useContext(EditorContext);
  const editor = editorContext.editorSession.id;

  const id = _.get(widgetProps, "uid");
  const type = _.get(widgetProps, "type");

  const breakpoint = useSelector((state) =>
    _.get(state, `${editor}.present.breakpoint`)
  );
  const childrenSelection = useChildrenWidgetSelected(editor, id);
  const stretched = _.get(widgetProps, "properties.desktop.stretched", false);

  const questionDesign = _.get(
    widgetProps,
    `properties.${breakpoint}.questionDesign`,
    {}
  );
  const seekLayoutType = _.get(questionDesign, `type`, "bar");

  var seekWidgetStyle = {
    ...style,
    ...getStyles(widgetProps, breakpoint, seekLayoutType),
  };

  return (
    <div
      id={id}
      ref={ref}
      className={cx(className, styles.seekContainer, "widget", {
        [styles.stretched]: stretched,
        [styles.partialSelection]: childrenSelection.selected,
        [styles.mobile]: breakpoint === "mobile",
      })}
      style={seekWidgetStyle}
      data-widget-id={id}
      data-widget-type={type}
      data-selectable={true}
    >
      <div style={{ pointerEvents: "none" }}>
        <Widgets.SeekSearchBox
          className={styles.searchBar}
          widgetProps={widgetProps}
          breakpoint={breakpoint}
        />
      </div>
    </div>
  );
};

const SeekWidgetDesktopAction = (props) => {
  const dispatch = useDispatch();
  const [view, setView] = useState(null);

  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const brandkitEnabled = _.get(workspace, 'brandkitEnabled', false);

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;
  const storyboardContext = React.useContext(StoryboardContext);

  const allowBrandkit = useSelector((state) =>
    _.get(state, `${editorSession}.present.entityType`)) !== 'PALETTE_COMPONENT';

  const id = _.get(props, "uid");
  const breakpoint = useSelector((state) =>
    _.get(state, `${editorSession}.present.breakpoint`)
  );
  const questionDesign = _.get(
    props,
    `properties.${breakpoint}.questionDesign`,
    {}
  );
  const layoutType = _.get(
    props,
    `properties.${breakpoint}.questionDesign.type`
  );

  const changeSettingsView = (view) => {
    setView(view);
  };

  const closePopup = () => {
    setView(null);
  };

  return (
    <>
      <SeekLayoutTypeDropdown
        layoutType={layoutType}
        id={id}
        questionDesign={questionDesign}
        breakpoint={breakpoint}
        editorSession={editorSession}
      />
      <Property.Action
        className={styles.iconButton}
        tooltip='Bar Customization'
        onClick={() => changeSettingsView("questionDesign")}
      >
        <i className={cx("cleverstory-customize", styles.seekIcons)} />
      </Property.Action>
      <Property.Divider />
      <Property.Action
        className={styles.iconButton}
        tooltip='Font Settings'
        onClick={() => changeSettingsView("fontStyles")}
      >
        <i className={cx('cleverstory-text-layer', styles.textLayerIcon)} />
      </Property.Action>
      <Property.Divider />
      <Property.Action
        className={styles.textButton}
        onClick={() => changeSettingsView("responsive")}
      >
        Response Design
      </Property.Action>
      <Property.Divider />
      {storyboardContext.type !== "INTERACTIVE_CONTENT" && (
        <Property.Action
          className={styles.iconButton}
          tooltip='Stretch'
          onClick={() => changeSettingsView("stretch")}
        >
          <i className={cx("cleverstory-stretch", styles.seekIcons)} />
        </Property.Action>
      )}
      {brandkitEnabled && allowBrandkit && userRoleService.canManageUsers() &&
        <Property.Action className={styles.iconButton} tooltip='Add to Brand Kit' onClick={() => changeSettingsView('brandMedia')}>
          <i className={'cleverstory-brandmedia'} />
        </Property.Action>
      }

      <Property.Divider />

      {view === "responsive" && (
        <ResponsiveDesign
          show={true}
          editorSession={editorSession}
          id={id}
          widgetProps={props}
          onClose={() => closePopup()}
        />
      )}

      {view === "stretch" && (
        <StretchDialog
          id={id}
          editor={editorSession}
          widget={props}
          onCancel={() => {
            closePopup();
          }}
        />
      )}

      {view === "fontStyles" && (
        <FontStylesEditor
          id={id}
          widget={props}
          onCancel={() => closePopup()}
        />
      )}

      {view === "questionDesign" && (
        <QuestionDesignSettings
          id={id}
          widget={props}
          onCancel={() => closePopup()}
        />
      )}
      {view === 'brandMedia' &&
        <BrandComponentProperty type={'SEEK'} widgets={[props]} onCancel={() => closePopup()} />
      }
    </>
  );
};

const SeekWidgetMobileAction = (props) => {
  const [view, setView] = useState(null);

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;

  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const brandkitEnabled = _.get(workspace, 'brandkitEnabled', false);

  const allowBrandkit = useSelector((state) =>
    _.get(state, `${editorSession}.present.entityType`)) !== 'PALETTE_COMPONENT';
  
  const storyboardContext = React.useContext(StoryboardContext);

  const id = _.get(props, "uid");
  const breakpoint = useSelector((state) =>
    _.get(state, `${editorSession}.present.breakpoint`)
  );
  const questionDesign = _.get(
    props,
    `properties.${breakpoint}.questionDesign`,
    {}
  );
  const layoutType = _.get(
    props,
    `properties.${breakpoint}.questionDesign.type`
  );

  const changeView = (view) => {
    setView(view);
  };

  const closePopup = () => {
    setView(null);
  };

  return (
    <>
      <SeekLayoutTypeDropdown
        id={id}
        editorSession={editorSession}
        questionDesign={questionDesign}
        layoutType={layoutType}
        breakpoint={breakpoint}
      />
      <Property.Action
        className={styles.iconButton}
        tooltip='Font Settings'
        onClick={() => changeView("fontStyle")}
      >
        <i className={cx('cleverstory-text-layer', styles.textLayerIcon)} />
      </Property.Action>
      <Property.Divider />
      <Property.Action
        className={styles.textButton}
        onClick={() => changeView("responsive")}
      >
        Response Design
      </Property.Action>
      <Property.Divider />
      {storyboardContext.type !== "INTERACTIVE_CONTENT" && (
        <Property.Action
          className={styles.iconButton}
          tooltip='Stretch'
          onClick={() => changeView("stretch")}
        >
          <i className={cx("cleverstory-stretch", styles.seekIcons)} />
        </Property.Action>
      )}
      {brandkitEnabled && allowBrandkit && userRoleService.canManageUsers() &&
        <Property.Action className={styles.iconButton} tooltip='Add to Brand Kit' onClick={() => changeView('brandMedia')}>
          <i className={'cleverstory-brandmedia'} />
        </Property.Action>
      }

      {view === "responsive" && (
        <ResponsiveDesign
          show={true}
          id={id}
          editorSession={editorSession}
          widgetProps={props}
          onClose={closePopup}
        />
      )}

      {view === "stretch" && (
        <StretchDialog
          id={id}
          editor={editorSession}
          widget={props}
          onCancel={() => {
            closePopup();
          }}
        />
      )}

      {view === "fontStyle" && (
        <FontStylesEditor
          id={id}
          widget={props}
          onCancel={() => closePopup()}
        />
      )}
      {view === 'brandMedia' &&
        <BrandComponentProperty type={'SEEK'} widgets={[props]} onCancel={() => closePopup()} />
      }
    </>
  );
};

const SeekWidget = React.forwardRef((props, ref) => {
  return <SeekWidgetView {...props} ref={ref} />;
});

const SeekLayoutTypeDropdown = ({
  id,
  editorSession,
  breakpoint,
  questionDesign,
  layoutType,
}) => {
  const dispatch = useDispatch();

  const seekLayoutOptions = [
    {
      id: 1,
      label: "Bar",
      value: "bar",
    },
    {
      id: 2,
      label: "Icon/Button",
      value: "button",
    },
  ];
  const selectedLayoutType = _.find(seekLayoutOptions, { value: layoutType });

  const changeSeekLayout = (layout) => {
    if (!layout) return;

    var layoutRequest = {
      questionDesign: {
        ...questionDesign,
        type: layout.value,
      },
    };
    dispatch(
      updateWidgetProperty(editorSession, id, breakpoint, layoutRequest)
    );
  };

  const MenuWrapper = (props) => {
    return (
      <components.Menu {...props} className={styles.optionMenuWrapper}>
        {props.children}
      </components.Menu>
    );
  };

  const OptionList = (props) => {
    return (
      <components.Option {...props} className={styles.list}>
        {props.children}
      </components.Option>
    );
  };

  return (
    <div className={styles.typeContainer}>
      <span className={styles.label}>Type</span>
      <Property.Dropdown
        searchable={false}
        disabled={true}
        placeholder={""}
        value={selectedLayoutType.value}
        className={styles.dropdownSelection}
        components={{
          Menu: MenuWrapper,
          Option: OptionList,
        }}
        options={seekLayoutOptions}
        onChange={changeSeekLayout}
      />
    </div>
  );
};

const FontStylesEditor = ({ id, widget, onCancel }) => {
  const dispatch = useDispatch();

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;
  const breakpoint = useSelector((state) =>
    _.get(state, `${editorSession}.present.breakpoint`)
  );
  const handlePropertyChange = (type, value) => {
    const request = {
      [type]: value,
    };
    dispatch(updateWidgetProperty(editorSession, id, breakpoint, request));
  };

  return (
    <Property.Dialog
      className={styles.fontStyleDialog}
      width={246}
      target={`#${id}`}
      title={"Font Settings"}
      onCancel={onCancel}
    >
      <Property.Body>
        <FontBackgroundSettings
          id={id}
          widget={widget}
          handlePropertyChange={handlePropertyChange}
          breakpoint={breakpoint}
          onCancel={onCancel}
        />
      </Property.Body>
    </Property.Dialog>
  );
};

const QuestionDesignSettings = ({ id, widget, onCancel }) => {
  const dispatch = useDispatch();

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;
  const breakpoint = useSelector((state) =>
    _.get(state, `${editorSession}.present.breakpoint`)
  );
  const handlePropertyChange = (type, value) => {
    const request = {
      [type]: value,
    };
    dispatch(updateWidgetProperty(editorSession, id, breakpoint, request));
  };

  return (
    <Property.Dialog
      className={styles.BarCustomDialog}
      width={246}
      target={`#${id}`}
      title={"Bar Customization"}
      onCancel={onCancel}
    >
      <Property.Body className={styles.bodyStyles}>
        <SeekLayoutSettings
          id={id}
          widget={widget}
          breakpoint={breakpoint}
          handlePropertyChange={handlePropertyChange}
          onCancel={onCancel}
        />
      </Property.Body>
    </Property.Dialog>
  );
};

export const StretchDialog = ({ id, widget, position, ...rest }) => {
  const dispatch = useDispatch();

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;

  const breakpoint = useSelector((state) =>
    _.get(state, `${editorSession}.present.breakpoint`)
  );
  const properties = _.get(widget, `properties.${breakpoint}`, {});
  const margin = _.get(properties, "margin", 0);
  const padding = _.get(properties, "padding", 0);

  const stretched = _.get(properties, "stretched", false);
  const layout = _.get(widget, `properties.${breakpoint}.layout`);

  const pageWidget = usePageWidgetSelector(editorSession, widget.uid);
  const pageWidth = _.get(pageWidget, "properties.desktop.container.minWidth");

  const handlePropertyChange = (value) => {
    dispatch(updateWidgetProperty(editorSession, widget.uid, breakpoint, value));
  };

  const handleMarginChange = (value) => {
    handlePropertyChange({
      margin: value,
    });
  };

  const handlePaddingChange = (value) => {
    handlePropertyChange({
      padding: value,
    });
  };

  const handleSeekSectionSize = (stretched) => {
    var frame = new Frame(layout);
    const rect = getBoundingRectFromLayout(layout);

    if (stretched) {
      frame.remove("width");
      frame.set("transform", "translate", `0px, ${rect.y}px`);
    } else {
      frame.set("width", `${pageWidth}px`);
      frame.set("transform", "translate", `0px, ${rect.y}px`);
    }

    handlePropertyChange({
      stretched: stretched,
      layout: frame.get(),
    });
  };

  return (
    <Property.Dialog
      className={styles.stretchSeekDialog}
      width={246}
      target={`#${id}`}
      title={"Stretch Section"}
      onCancel={rest.onCancel}
    >
      <Property.Body>
        {breakpoint === "desktop" && (
          <Property className={styles.sectionSizeProperty}>
            <div className={styles.seekSizeContainer}>
              <div
                className={cx(styles.seekSize, styles.stretched, {
                  [styles.active]: stretched,
                })}
                onClick={() => handleSeekSectionSize(true)}
              >
                <div className={styles.icon}>
                  <div className={styles.inner}></div>
                </div>
                <label>Screen</label>
              </div>
              <div
                className={cx(styles.seekSize, {
                  [styles.active]: !stretched,
                })}
                onClick={() => handleSeekSectionSize(false)}
              >
                <div className={styles.icon}>
                  <div className={styles.inner}></div>
                </div>
                <label>Page</label>
              </div>
            </div>
          </Property>
        )}
        {stretched && breakpoint === "desktop" && (
          <Property name="Margin Spacing" className={styles.marginProperty}>
            <Property.Slider
              min={0}
              max={190}
              step={1}
              input
              value={margin}
              onChange={handleMarginChange}
            />
          </Property>
        )}
        {breakpoint === "mobile" && (
          <Property name="Padding" className={styles.marginProperty}>
            <Property.Slider
              min={0}
              max={40}
              step={1}
              input
              value={padding}
              onChange={handlePaddingChange}
            />
          </Property>
        )}
      </Property.Body>
    </Property.Dialog>
  );
};

SeekWidget.actions = (editorSession, breakpoint, props) => {
  return (
    <>
      {breakpoint === "desktop" && (
        <SeekWidgetDesktopAction
          editorSession={editorSession}
          breakpoint={breakpoint}
          {...props}
        />
      )}
      {breakpoint === "mobile" && (
        <SeekWidgetMobileAction
          editorSession={editorSession}
          breakpoint={breakpoint}
          {...props}
        />
      )}
    </>
  );
};

SeekWidget.processRequest = (widget) => {
  var background = _.get(widget, "properties.desktop.background");

  if (!background) {
    return widget;
  }

  var media = _.get(background, "media");
  if (media) {
    background = {
      ...background,
      media: media.id,
    };
  }

  var layout = _.get(widget, "properties.desktop.layout");
  const frame = new Frame(layout);

  if (!layout.width) {
    frame.remove("width");
  }

  return {
    ...widget,
    properties: {
      ...widget.properties,
      desktop: {
        ...widget.properties.desktop,
        background: background,
        layout: frame.get(),
      },
    },
  };
};

SeekWidget.moveableConfig = (editorSession, widget, breakpoint) => {
  return {
    draggable: true,
    resizable: false,
    rotatable: false,
    renderDirections: [],
    onDrag: (layout) => {
      const frame = new Frame(layout);
      const translate = frame.get("transform", "translate");
      const values = _.split(translate, ",");
      const element = document.querySelector('[data-storyboard-type]');
      const storyboardType = element?.getAttribute('data-storyboard-type');

      var y = parseInt(values[1]);
      if (['INTERACTIVE_CONTENT', 'SPATIAL'].includes(storyboardType)){
        y = Math.max(0, y);
      }

      const newTranslate = `0px, ${y}px`;

      frame.set("transform", "translate", newTranslate);
      return frame.get();
    },
    onResize: (widget, layout, breakpoint) => {
      const stretched = _.get(widget, "properties.desktop.stretched");

      const frame = new Frame(layout);
      if (stretched && breakpoint === "desktop") {
        const margin = _.get(widget, "properties.desktop.margin", 0);
        const width = `calc(var(--editor-width) - 2 * ${margin}px)`;
        frame.set("width", width);
        return frame.get();
      }

      if (breakpoint === "mobile") {
        const frame = new Frame(layout);
        frame.set("width", "100%");
        frame.set("height", 'auto');
        return frame.get();
      }

      return frame.get();
    },
    onReparent: (widget, parent) => {
      const type = getWidgetType(editorSession, parent)
      if (type === PAGE) return true;
      return false;
    },
  };
};

function getStyles(properties, breakpoint, type) {
  var styles = {};

  if (!properties) {
    return styles;
  }
  const defaultProperties = _.get(properties, `properties.desktop`);
  const deviceProperties = _.get(properties, `properties.${breakpoint}`);

  const stretched = _.get(defaultProperties, "stretched", false);
  const margin = _.get(defaultProperties, "margin", 0);
  const padding = _.get(deviceProperties, `padding`, 0);

  var styles = {
    marginLeft: 0,
  };

  //background
  const backgroundRgb = _.get(
    deviceProperties,
    `questionDesign.${type}.backgroundColor`,
    null
  );
  var background = "inherit";
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb);
  }

  styles["background"] = background;

  if (breakpoint === "desktop") {
    styles = {
      ...styles,
      paddingLeft: `0px`,
      paddingRight: `0px`,
    };

    if (stretched) {
      styles = {
        ...styles,
        width: `calc(var(--editor-width) - 2 * ${margin}px)`,
        left: `calc((100% - (var(--editor-width) - 2 * ${margin}px))/2)`,
      };
    }
  }

  if (breakpoint === "mobile") {
    styles = {
      ...styles,
      paddingLeft: `0px`,
      paddingRight: `0px`,
    };
  }

  return styles;
}

const seekWidgetEquals = function (prevProps, nextProps) {
  const paths = ["className", "style", "widgetProps", "widgetRef", "children"];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
};

const SeekWidgetView = React.memo(SeekWidgetViewComponent, seekWidgetEquals);

export { SeekWidget };
